/* eslint-disable no-unsafe-optional-chaining */
import { extendableComponent } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { Rating } from '@mui/material'
import { useEffect, useState } from 'react'
import useCallAPI from '../../hooks/useCallAPI'
import { ProductReviewsImageList } from './ProductReviewsImageList'
import ReviewChart from './ReviewChart'
import { ReviewItemTabs } from './ReviewItemTabs'

export type ProductReviewsProps = {
  productId: number | null | undefined
  customer: any | undefined
}

export function ProductReviews(props: ProductReviewsProps) {
  const { productId, customer } = props
  const [reviewsData, setReviewsData] = useState<any>()
  const name = 'ImageText' as const
  const parts = ['root'] as const
  const { classes } = extendableComponent(name, parts)

  const { apiCall: reviewsDataApiCall } = useCallAPI({
    url: `${process.env.NEXT_PUBLIC_YOTPO_API_URL}/v1/widget/${process.env.NEXT_PUBLIC_YOTPO_APP_KEY}/products/${productId}/reviews.json?per_page=150`,
    contentType: 'application/json',
    method: 'GET',
  })

  useEffect(() => {
    const fetchBottomLineData = async () => {
      const res = await reviewsDataApiCall()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      setReviewsData(res?.data?.response)
    }
    fetchBottomLineData().catch((e) => {
      // addtional error handling here, the error must be set by the useCallAPI hook already
      console.error(e)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId])

  if (!reviewsData || reviewsData?.reviews?.length < 1) {
    return null
  }

  const averageScoreRouned = Math.round(reviewsData?.bottomline?.average_score * 10) / 10
  return (
    <div className={`${classes.root}`}>
      {reviewsData && reviewsData?.reviews?.length > 0 && (
        <div className='gap-10 lg:grid lg:grid-cols-[30fr_70fr]'>
          <div>
            <span className='Type-XXXL-Medium text-black'>
              <Trans id='Reviews' />
            </span>
            <div className='Type-Base-Medium lg:Type-Large-Medium ml-[-8px] mt-10 pb-5 text-black lg:flex lg:items-center'>
              <Rating
                name='total-ratings'
                defaultValue={averageScoreRouned}
                size='large'
                readOnly
                precision={0.1}
                className='px-2 align-bottom'
              />
              <span className='Type-XL-Regular inline'>
                ({averageScoreRouned}) {reviewsData?.reviews?.length} Reviews
              </span>
            </div>
            <ReviewChart values={reviewsData?.bottomline?.star_distribution ?? {}} />
            <div className='Type-XXXL-Medium mb-5 hidden text-70-grey'>
              <span className='Type-H4-Bold text-parks-green lg:block'>
                {(reviewsData?.bottomline?.average_score / 5) * 100}%
              </span>{' '}
              <div className='inline lg:block'>
                <Trans id='Would order again' />
              </div>
            </div>
            {reviewsData?.images && reviewsData?.images?.length > 0 && (
              <ProductReviewsImageList images={reviewsData?.images} className='mb-20' />
            )}
          </div>
          <div className='mt-8 md:mt-0'>
            <div className='pb-5'>
              <ReviewItemTabs
                reviewsCount={reviewsData?.reviews?.length ?? 0}
                productId={productId}
                customer={customer}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
